import * as types from '../mutation-types/general'

const namespaced = true
export const namespace = 'General'

// state
const state = {
    counters: {},
}

// mutations
const mutations = {
    [types.SET_COUNTERS](s, counters) {
        s.counters = counters
    },
}

// actions
const actions = {
    setNotificationCounters({commit}, payload) {
        commit(types.SET_COUNTERS, payload)
    },

    fetchNotificationCounters({commit}) {
        axios.get('/api/customer/social-notification/counts').then(({data}) => {
            commit(types.SET_COUNTERS, data)
        })
    },
}

// getters
const getters = {
    notificationCounters: s => {
        return s.counters
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
